import React from 'react'

import { Button, Tooltip, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string, func, bool,
} from 'prop-types'

function ModelCardActionButton({
  className = '',
  icon,
  id,
  name,
  onClick,
  tooltipContent,
  isLoading = false,
  ...rest
}) {
  return (
    <Tooltip
      content={tooltipContent}
      id={`${name}-${id}`}
      randomizeID
      onClick={() => onClick(id)}
      containerClass={className}
      offset={{ top: 10 }}
      disableMobileEvent
    >
      {/* The tooltip is react-tooltip (data-for), not aria-labelledby/describedby, and the button
          renders an empty icon span - so without aria-label these controls are announced as an
          unlabelled "button". The tooltip copy is the same text a sighted user gets. */}
      <Button
        icon={<span className={classnames('button-icon', icon)} />}
        variant="only-icon"
        disabled={isLoading}
        // Triangle's Button maps actionType to the native type and defaults it to '', which the
        // HTML spec treats as submit. None of these are submit controls.
        actionType="button"
        aria-label={tooltipContent}
        {...rest}
      />
    </Tooltip>
  )
}

ModelCardActionButton.propTypes = {
  className: string,
  icon: string.isRequired,
  id: string.isRequired,
  name: string.isRequired,
  onClick: func.isRequired,
  tooltipContent: string.isRequired,
  isLoading: bool,
}

export default ModelCardActionButton
